import { render } from "./RepresentationSelection.vue?vue&type=template&id=9f43eb1e&scoped=true"
import script from "./RepresentationSelection.vue?vue&type=script&lang=js"
export * from "./RepresentationSelection.vue?vue&type=script&lang=js"

import "./RepresentationSelection.vue?vue&type=style&index=0&id=9f43eb1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f43eb1e"],['__file',"src/components/list-items/RepresentationSelection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9f43eb1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9f43eb1e', __exports__)) {
    api.reload('9f43eb1e', __exports__)
  }
  
  module.hot.accept("./RepresentationSelection.vue?vue&type=template&id=9f43eb1e&scoped=true", () => {
    api.rerender('9f43eb1e', render)
  })

}


export default __exports__